export class Feature {
    public OptionID: string;
    public Fragment: string;
    public Description: string;
    public Prerequisites: string;
    public Incompatibilities: string;
    public AllowISO: string = '';
    public DenyISO: string = '';
    public NReferences: number;
    //public Selected: boolean;
    public IsMandatory: boolean = false;
    public Discontinued: boolean;
    public Status: number;
    public HasFlatPrice: boolean;
    public Options: Option[];
    public isChecked: boolean = false;
    public CurrNrOfUser: number = 0;
    public SelectedByUser: boolean = false;
    public Level: number;
    public GroupCode: string;
    public StartValidityDate: Date;
    public EndValidityDate: Date;
    public ReleaseFrom: string;
    public ReleaseTo: string;
}
export class Option {
    public edition: string;
    public availability: string;
    public Price: number;
    public MaxUserLicence: number = 1;

    constructor() {}
}

export class OptionInfo {
    public optionID: string;
    public fragment: string;
    public selectedEdition: string;
    public price: number;
    public nrOfUser: number = 1;
}

export class TogglerElement {
    type: string;
    checked: boolean;
    nrOfUser: number;
}

export class AccordionElement {
    public module: Feature = new Feature();
    public funtionlities: Feature[] = [];
    public status: number;
    public fragment: string;
}

export class OrderPreviewRows {
    public itemDescription: string;
    public itemCode: string;
    public qty: number;
    public price: number;
    public totalPrice: number;
}

export class FeatureDetail {
    public itemDescription: string;
    public OptionsSTD: string;
    public OptionsPRM: string;
    public OptionsPRO: string;
    public OptionsENT: string;
    public Level: string;
    public DenyISO: string;
    public Details: string;
    public AllowISO: string;
}

export class AlaCarteElement {
    public optionID: string;
    public hasFlatPrice: boolean;
}
